import React from "react";

const RemarksCellRenderer = ({ row }) => {
    const remarks = row.remarks || "";

    return (
        <span className="schedule-draft-rdg-remarks-cell" title={remarks} style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {remarks}
        </span>
    );
};

export default RemarksCellRenderer;
